import React from "react";
import { Route } from "react-router-dom";

import { stripeRoutes } from "./routes";

export const StripeRoutes = () => {
  return (
    <>
      {stripeRoutes.map(({ path, Component, exact = false }) => (
        <Route path={path} key={path} exact={exact}>
          <Component />
        </Route>
      ))}
    </>
  );
};
